import { SpaceBetween, FormField, Select } from '@amzn/awsui-components-react';
import { OptionDefinition } from '@amzn/awsui-components-react/polaris/internal/components/option/interfaces';
import { useLocalizedText } from '../../../../hooks/localizedText';
import { OptionalLabel } from './Common';
import { EventInput, Visibility } from '@amzn/red-velvet-api';
import { publishKatalMetric } from '../../../katalAnalytics';

export interface VisibilityComponentProps {
  currentFields: EventInput;
  updateFieldHandler: (fields: EventInput) => void;
  isReadOnly?: boolean;
  metricPrefix: string;
}

export function VisibilityComponent(props: VisibilityComponentProps) {
  const namespaces = ['events', 'translation'];
  const { t } = useLocalizedText(namespaces);

  const visibilityOption: Record<string, OptionDefinition> = {
    PUBLIC: { label: t('visibility.public'), value: Visibility.PUBLIC },
    PRIVATE_DIRECT_LINK: { label: t('visibility.private'), value: Visibility.PRIVATE_DIRECT_LINK },
  };

  // Derived every render rather than held in state: these labels come from t(), which serves the
  // English fallback until the ARB packs load. A selected option captured in useState would keep
  // that English label for the life of the form while the options list beside it rendered
  // translated. currentFields is the source of truth regardless — onChange writes visibility
  // straight back into it, so local state only duplicated the prop.
  const visibilityField = props.currentFields.visibility
    ? visibilityOption[props.currentFields.visibility]
    : visibilityOption.PUBLIC;

  return (
    <FormField
      label={
        <SpaceBetween direction="horizontal" size="l">
          <OptionalLabel>{t('eventDetailsStep.visibility')}</OptionalLabel>
        </SpaceBetween>
      }
      description={t('eventDetailsStep.visibilitySubText')}
    >
      <Select
        selectedOption={visibilityField}
        onChange={(event) => {
          publishKatalMetric(
            `${props.metricPrefix}_visibilityChanged`,
            event.detail.selectedOption.value ?? ''
          );
          props.updateFieldHandler({
            ...props.currentFields,
            visibility: event.detail.selectedOption.value as Visibility,
          });
        }}
        options={[visibilityOption.PUBLIC, visibilityOption.PRIVATE_DIRECT_LINK]}
        readOnly={props.isReadOnly}
      />
    </FormField>
  );
}
